<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label class="font-w400">{{
            (customertype == 1 || customertype == 2)
            ? translate[lang]["consumptionq3"]
            : translate[lang]["consumptionq3"]
        }}</label>
        <div class="situation" v-if="customertype == 1 || customertype == 2">
          <div
            v-for="item in consumptions"
            :key="item.id"
            class="familyItems"
            v-if="item.id <= 5"
          >
            <div class="utility">
              <input
                :id="'consumption' + item.id"
                name="consumption[family_situation]"
                type="radio"
                :value="item.id"
                v-model="cFamilySituation"
              />
              <label :for="'consumption' + item.id" class="familyLabel">
                <img
                  style="max-height: 80px"
                  :width="item.width"
                  v-if="item.image"
                  :src="getImage('/' + item.image)"
                  class="familyImage"
                />
                <span>
                  {{ item.name[lang] }}
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="situation" v-if="customertype == 9999">
          <div
            v-for="item in consumptions"
            :key="item.id"
            class="familyItems"
            v-if="item.id > 5"
          >
            <div class="utility">
              <input
                :id="'consumption' + item.id"
                name="consumption[family_situation]"
                type="radio"
                :value="item.id"
                v-model="cFamilySituation"
              />
              <label :for="'consumption' + item.id" class="familyLabel">
                <img
                  style="max-height: 80px"
                  :width="item.width"
                  v-if="item.image"
                  :src="getImage('/' + item.image)"
                  class="familyImage"
                />
                <span class="familySpan">
                  {{ item.name[lang] }}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "FamilySituation",
  data() {
    return {
      min: 1,
      max: 25000,
      modalcontent: {
        title: null,
        description: null
      }
    };
  },
  async created() {

    if(this.$route.query.household && this.$route.query.household < 6) {
      this.setFamilySituation(this.$route.query.household);
    }

    //
    await this.getConsumptionList().then(() => {});
    this.updateConsumptions();
    if (!this.isSubmittedForm) {
      if (this.customertype == 1) {
        //this.setFamilySituation(1);
      } else {
        this.setFamilySituation(6);
      }
    }
  },
  computed: {
    ...mapState({
      consumptions: state => state.forms.consumptions,
      familySituation: state => state.forms.consumption.familySituation,
      disciplineCode: state => state.forms.disciplinecode,
      water: state => state.forms.consumption.water,
      stadswarmte: state => state.forms.consumption.stadswarmte
    }),
    cFamilySituation: {
      get() {
        return this.familySituation;
      },
      set(val) {
        this.setFamilySituation(val);
      }
    }
  },
  watch: {
    disciplineCode: {
      handler: function() {
        this.updateConsumptions();
        if (this.isValidCityHeat() && this.hasGas() && !this.disabledForm) {
          this.setAndRemove(this.enums.cityheat.value, this.enums.gas.value);
        }
      },
      deep: true
    },
    customertype(val) {
      if (!this.isSubmittedForm) {
        if (val == 1) {
          this.setFamilySituation(1);
        } else {
          this.setFamilySituation(6);
        }
      }
    },
    selectedProducts: {
      handler: function(newArr, oldArr) {
        if (
          newArr.includes(this.enums.water.value) &&
          !oldArr.includes(this.enums.water.value)
        ) {
          this.updateConsumptions();
        }
        if (
          newArr.includes(this.enums.cityheat.value) &&
          !oldArr.includes(this.enums.cityheat.value)
        ) {
          this.updateConsumptions();
        }
      },
      deep: true
    },
    familySituation() {
      this.updateConsumptions();
    }
  },
  methods: {
    ...mapActions({
      getConsumptionList: "forms/getConsumptionList"
    }),
    isValidCityHeat() {
      return (
        this.disciplineCode != null &&
        this.disciplineCode.data.filter(x => x.disciplineCode === "H").length >
          0 &&
        this.products.filter(a => a.id == this.enums.cityheat.value).length > 0
      );
    },
    isValidWater() {
      return (
        this.disciplineCode != null &&
        this.disciplineCode.data.filter(x => x.disciplineCode === "W").length >
          0 &&
        this.products.filter(a => a.id == this.enums.water.value).length > 0
      );
    },
    hasGas() {
      return this.overview.filter(a => a.id == this.enums.gas.value).length > 0;
    },
    ...mapMutations({
      setFamilySituation: "forms/SET_FAMILY_SITUATION",
      setWater: "forms/SET_WATER",
      clearWater: "forms/CLEAR_WATER",
      setStadswarmte: "forms/SET_STADSWARMTE",
      clearStadswarmte: "forms/CLEAR_STADSWARMTE"
    }),
    async updateConsumptions() {
      await this.getConsumptionList();
      if (this.isValidWater()) {
        this.updateWaterConsumption(
          this.familySituation,
          this.disciplineCode.data.filter(x => x.disciplineCode === "W")[0]
        );
      } else if (
        (this.disciplineCode == null ||
          this.disciplineCode.data.filter(x => x.disciplineCode === "W")
            .length > 0) &&
        this.products.filter(a => a.id == this.enums.water.value).length > 0
      ) {
        this.clearWaterConsumption();
      }
      if (this.isValidCityHeat()) {
        this.updateStadswarmteConsumption(
          this.familySituation,
          this.disciplineCode.data.filter(x => x.disciplineCode === "H")[0]
        );
      } else if (
        (this.disciplineCode == null ||
          this.disciplineCode.data.filter(x => x.disciplineCode === "H")
            .length > 0) &&
        this.products.filter(a => a.id == this.enums.cityheat.value).length > 0
      ) {
        this.clearStadswarmteConsumption();
      }
    },
    updateWaterConsumption(people, water) {


      var waterr = water

      this.setWater(
        this.consumptions.filter(x => x.id == people)[0]
          ? this.consumptions.filter(x => x.id == people)[0].water
          : {}
      );

      //set overview
      if (this.overview.filter(x => x.group === "water").length > 0) {
        this.overview.filter(x => x.group === "water")[0].supplier.id =
          water.supplier_id;
        this.overview.filter(x => x.group === "water")[0].total = this.water
          .monthly_price
          ? parseFloat(this.water.monthly_price)
          : 0;
        this.overview.filter(x => x.group === "water")[0].yearly = this.water
          .yearly_price
          ? parseFloat(this.water.yearly_price)
          : 0;
        this.overview.filter(x => x.group === "water")[0].supplier.title =
          water.supplier_name;
        this.overview.filter(x => x.group === "water")[0].usage = this.water
          .m3_monthly
          ? parseFloat(this.water.m3_monthly)
          : 0;

        this.overview.filter(x => x.group === "water")[0].logo = waterr.logo

      }
    },
    updateStadswarmteConsumption(people, stadswarmte) {
      let supplier_id = stadswarmte.supplier_id;

      let stadswarmteConsumption = this.consumptions.filter(
        x => x.id == people
      )[0].heating;
      let currentSupplier = stadswarmteConsumption.prices
        ? stadswarmteConsumption.prices.filter(a => a.id == supplier_id)[0]
        : {};
      this.setStadswarmte({
        monthly_price: parseFloat(currentSupplier.price) / 12,
        yearly_price: parseFloat(currentSupplier.price),
        m3_monthly: stadswarmteConsumption.m3_monthly,
        logo: stadswarmte.logo
      });
      //set Overview
      if (this.overview.filter(x => x.group === "cityheat").length > 0) {
        this.overview.filter(x => x.group === "cityheat")[0].supplier.id =
          stadswarmte.supplier_id;
        this.overview.filter(x => x.group === "cityheat")[0].total = this
          .stadswarmte.monthly_price
          ? parseFloat(this.stadswarmte.monthly_price)
          : 0;
        this.overview.filter(x => x.group === "cityheat")[0].yearly = this
          .stadswarmte.yearly_price
          ? parseFloat(this.stadswarmte.yearly_price)
          : 0;
        this.overview.filter(x => x.group === "cityheat")[0].supplier.title =
          currentSupplier.name;
        this.overview.filter(x => x.group === "cityheat")[0].usage = this
          .stadswarmte.m3_monthly
          ? parseFloat(this.stadswarmte.m3_monthly)
          : 0;

        // logo
        this.overview.filter(x => x.group === "cityheat")[0].logo = this.stadswarmte.logo

      }
    },
    clearWaterConsumption() {
      this.clearWater();
      //clear overview
      if (this.overview.filter(x => x.group === "water").length > 0) {
        this.overview.filter(
          x => x.group === "water"
        )[0].supplier.id = undefined;
        this.overview.filter(x => x.group === "water")[0].total = parseFloat(
          this.water.monthly_price
        );
        this.overview.filter(x => x.group === "water")[0].yearly = parseFloat(
          this.water.yearly_price
        );
        this.overview.filter(
          x => x.group === "water"
        )[0].supplier.title = undefined;
        this.overview.filter(x => x.group === "water")[0].usage = parseFloat(
          this.water.m3_monthly
        );
      }
    },
    clearStadswarmteConsumption() {
      this.clearStadswarmte();
      //clear overview
      if (this.overview.filter(x => x.group === "cityheat").length > 0) {
        this.overview.filter(
          x => x.group === "cityheat"
        )[0].supplier.id = undefined;
        this.overview.filter(x => x.group === "cityheat")[0].total = parseFloat(
          this.stadswarmte.monthly_price
        );
        this.overview.filter(
          x => x.group === "cityheat"
        )[0].yearly = parseFloat(this.stadswarmte.yearly_price);
        this.overview.filter(
          x => x.group === "cityheat"
        )[0].supplier.title = undefined;
        this.overview.filter(x => x.group === "cityheat")[0].usage = parseFloat(
          this.stadswarmte.m3_monthly
        );
      }
    },
    setAndRemove(set, remove) {
      if (this.selectedProducts.includes(remove)) {
        this.removeProduct(
          remove,
          this.form.data.fields.filter(
            a =>
              a.type == "products" &&
              a.products.findIndex(b => b.id == remove) >= 0
          )[0]
        );
      }
      if (!this.selectedProducts.includes(set)) {
        this.form.data.fields
          .filter(
            a =>
              a.type == "products" &&
              a.products.findIndex(b => b.id == set) >= 0
          )[0]
          .defaultProducts.push(set);
      }
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .situation {
  }
  .familyImage {
    display: none;
  }
  .familyLabel {
    height: 50px;
  }
  .familySpan {
  }
}

@media only screen and (min-width: 601px) {
  .situation {
    display: flex;
    justify-content: space-between;
  }
  .familyItems {
    flex: 0.18;
  }
  .familyLabel {
    height: 130px;
  }
  .familySpan {
    display: flex;
    align-self: center;
    flex-direction: column;
    margin-top: 40%;
  }
}
</style>
